<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0" [ttHeading]="tabletSize.matches ? 'h_webpage_setting_edit' : undefined" ttTranslateHeading>
        <tt-input ttLabel="p2_webpage_setting_keyno" [ttModel]="page.p2_webpage_setting_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name_translated" [ttModel]="page.webpage_name_translated" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name" [ttModel]="page.webpage_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="include" [(ttModel)]="page.include"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving" ttTextAlign="center"></tt-button-save>
    </tt-card>
</tt-page>
